"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNUP_CANCEL_NOTE_COPY = exports.SIGNUP_CANCEL_COPY = void 0;
/**
 * AN-28 (Anthony: "never ever will we give the user the option to skip this step;
 * either they cancel or they continue"; Paul, 2026-10-12: Cancel signs out and goes
 * home). The account already exists by these screens, so Cancel keeps it and the
 * note says so. One copy for both apps.
 */
exports.SIGNUP_CANCEL_COPY = "Cancel";
exports.SIGNUP_CANCEL_NOTE_COPY = "We'll keep your account. Sign in any time to pick up where you left off.";
//# sourceMappingURL=signupCancelCopy.js.map